import React from 'react';
import { Button } from 'react-bootstrap';
import styled from 'styled-components';
import { COLOR } from '../common/uiTokens';

export const NotificationTabContainer = styled.div`
  .nav-tabs {
    display: flex;
    justify-content: center;
    background-color: ${COLOR.grayBg};
    border-radius: 10px;
    padding: 2px;
    border:none !important;
  }

  .nav-item {
    display: flex;
    align-items: center; /* Center vertically */
  }

  .nav-item .nav-link.active {
    color: #fff;
    background: ${COLOR.navy};
    border-radius: 13.899px;
    font-size: 8.002px !important;
    width: 51.476px;
    height: 25.413px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -0.24px;
    align-items: center;
  }

  .nav-item .nav-link {
    color: ${COLOR.navy};
    font-size: 8.002px !important;
    width: 51.476px;
    height: 25.413px;
    border-radius: 13.899px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -0.24px;
  }
`;

export const HorizontalLine = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${COLOR.grayBorder};
`;
export const ViewAllButton = styled(Button)`
&&&{
    background: ${COLOR.navy} !important;
    border: none !important;
    font-size: 13px !important;
    font-style: normal !important;
    font-weight: 600 !important;
    line-height: normal !important;
    border-radius: 8px !important;
    padding: 9px 16px !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 6px !important;
}
`;
export const MarkReadButton = styled(ViewAllButton)`
&&&{
    color: ${COLOR.textPrimary} !important;
    background: #fff !important;
    border: 1px solid ${COLOR.grayBorder} !important;
}
`;
export const LoadMoreButton = styled(MarkReadButton)`
&&&{
    width: 100%;
}
`;
export const NotificationMessageContainer = styled.div`
    padding:10px 12px;
    width: 100%;
    flex-shrink: 0;
    border-radius: 8px;
    background: ${COLOR.grayBg};
    &.clickable{
        cursor: pointer;
    }
    &.clickable:hover{
        background: #eef1f8;
    }
    /* Unread is the only state the badge is derived from, so it has to be visible. */
    &.unread{
        background: #FFF;
        border: 1px solid ${COLOR.grayBorder};
        border-left: 3px solid ${COLOR.navy};
    }
    .MessageHeader{
        color: ${COLOR.textPrimary};
        font-size: 13px;
        font-style: normal;
        font-weight: 600;
        line-height: 1.35;
    }
    &.unread .MessageHeader{
        font-weight: 700;
    }
    .unread-dot{
        display: inline-block;
        width: 6px;
        height: 6px;
        margin-right: 5px;
        border-radius: 50%;
        background: ${COLOR.link};
        vertical-align: middle;
    }
    .MessageBody{
        color: ${COLOR.textSecondary};
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 1.45;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }
    .datetime{
        color: ${COLOR.textMuted};
        font-size: 11px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }
`;
